export default __webpack_public_path__ + "static/media/software.3aa8321d.svg";